import React, {useState} from "react";

import './BlockForm.css'
import Checkbox from "../ui/checkbox/checkbox";
import API from "../api";

export default function BlockForm(props) {
    const [isChecked, setChecked] = useState(false)
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')

    const onClick = () => {
        if (isChecked) {
            API.postRequestCall(name, phone)
                .then(data => {
                    props.addSnackbar("Спасибо, мы перезвоним вам в ближайшее время", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                })
                .catch(error => {
                    props.addSnackbar("Не получилось отправить заявку", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }
    }

    return <div className='block-form'>
        <div className='content'>
            <div className='header'>
                <div className='title'>
                    Записывайтесь на приём уже сейчас
                </div>
                <div className='description'>
                    Заполните форму, чтобы получить персональную консультацию по лечению, реставрации или
                    эстетической коррекции зубов
                </div>
            </div>
            <div className='tags'>
                <div className='tag'>
                    Отправьте заявку, и мы перезвоним вам в ближайшее время
                </div>
            </div>
        </div>
        <div className='form'>
            <div className='inputs'>
                <input placeholder='Ваше имя' value={name} onChange={(e) => setName(e.target.value)}/>
                <input placeholder='Номер телефона' value={phone} onChange={(e) => setPhone(e.target.value)}/>
            </div>
            <div className='consent'>
                <Checkbox
                    checked={isChecked}
                    onChange={(checked) => setChecked(checked)}
                />
                <div className='text'>
                    Я подтверждаю свое согласие на обработку
                    и хранение персональных данных
                </div>
            </div>
            <div className={`button ${!isChecked ? 'disabled' : ''}`} onClick={onClick}>
                Записаться на приём
            </div>
        </div>
    </div>
}